import React from 'react';

export const KeycapDarkIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 191 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1 4C1 1.79086 2.79086 0 5 0H186C188.209 0 190 1.79086 190 4V60C190 62.2091 188.209 64 186 64H5C2.79086 64 1 62.2091 1 60V4Z"
      fill="#192232"
    />
    <path
      d="M5 8C5 5.79086 6.79086 4 9 4H85C87.2091 4 89 5.79086 89 8V56C89 58.2091 87.2091 60 85 60H9C6.79086 60 5 58.2091 5 56V8Z"
      fill="#192232"
    />
    <g clipPath="url(#paint0_angular_14845_15382_clip_path)">
      <g transform="matrix(-0.0540622 0.0552909 -0.0540622 -0.0552909 90.3125 3.12499)">
        <foreignObject x="-1321.64" y="-1321.64" width="2643.28" height="2643.28">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              background:
                'conic-gradient(from 90deg,rgba(79, 95, 118, 0.5) 0deg,rgba(79, 95, 118, 1) 14.4deg,rgba(79, 95, 118, 0) 345.6deg,rgba(79, 95, 118, 0.5) 360deg)',
              height: '100%',
              width: '100%',
              opacity: 1,
            }}
          ></div>
        </foreignObject>
      </g>
    </g>
    <path
      d="M5 8C5 5.79086 6.79086 4 9 4H85C87.2091 4 89 5.79086 89 8V56C89 58.2091 87.2091 60 85 60H9C6.79086 60 5 58.2091 5 56V8Z"
      fill="url(#paint2_linear_14845_15382)"
      fillOpacity="0.75"
    />
    <g style={{ mixBlendMode: 'multiply' }} filter="url(#filter0_f_14845_15382)">
      <path d="M88.5 56L80.5 96H12.5L4.5 56H88.5Z" fill="url(#paint3_linear_14845_15382)" />
    </g>
    <path
      d="M5 36C5 33.7909 6.79086 32 9 32H85C87.2091 32 89 33.7909 89 36V56C89 58.2091 87.2091 60 85 60H9C6.79086 60 5 58.2091 5 56V36Z"
      fill="#192232"
    />
    <path
      d="M5 36C5 33.7909 6.79086 32 9 32H85C87.2091 32 89 33.7909 89 36V56C89 58.2091 87.2091 60 85 60H9C6.79086 60 5 58.2091 5 56V36Z"
      fill="url(#paint6_linear_14845_15382)"
      fillOpacity="0.75"
    />
    <g filter="url(#filter1_i_14845_15382)">
      <path
        d="M13 31.2C13 24.4794 13 21.1191 14.3079 18.5521C15.4584 16.2942 17.2942 14.4584 19.5521 13.3079C22.1191 12 25.4794 12 32.2 12H61.8C68.5206 12 71.8809 12 74.4479 13.3079C76.7058 14.4584 78.5416 16.2942 79.6921 18.5521C81 21.1191 81 24.4794 81 31.2V32.8C81 39.5206 81 42.8809 79.6921 45.4479C78.5416 47.7058 76.7058 49.5416 74.4479 50.6921C71.8809 52 68.5206 52 61.8 52H32.2C25.4794 52 22.1191 52 19.5521 50.6921C17.2942 49.5416 15.4584 47.7058 14.3079 45.4479C13 42.8809 13 39.5206 13 32.8V31.2Z"
        fill="#243043"
      />
      <path
        d="M13 31.2C13 24.4794 13 21.1191 14.3079 18.5521C15.4584 16.2942 17.2942 14.4584 19.5521 13.3079C22.1191 12 25.4794 12 32.2 12H61.8C68.5206 12 71.8809 12 74.4479 13.3079C76.7058 14.4584 78.5416 16.2942 79.6921 18.5521C81 21.1191 81 24.4794 81 31.2V32.8C81 39.5206 81 42.8809 79.6921 45.4479C78.5416 47.7058 76.7058 49.5416 74.4479 50.6921C71.8809 52 68.5206 52 61.8 52H32.2C25.4794 52 22.1191 52 19.5521 50.6921C17.2942 49.5416 15.4584 47.7058 14.3079 45.4479C13 42.8809 13 39.5206 13 32.8V31.2Z"
        fill="url(#paint7_radial_14845_15382)"
      />
      <path
        d="M29.592 32.088C29.592 29.032 31.512 27.032 33.992 27.032C36.056 27.032 37.416 28.232 37.816 30.056H36.568C36.168 28.92 35.352 28.168 33.992 28.168C32.12 28.168 30.856 29.752 30.856 32.088C30.856 34.408 32.104 36.008 33.992 36.008C35.352 36.008 36.168 35.256 36.568 34.104H37.816C37.416 35.944 36.04 37.144 33.992 37.144C31.512 37.144 29.592 35.144 29.592 32.088ZM38.5894 28.296V27.176H46.7014V28.296H43.2774V37H42.0134V28.296H38.5894ZM51.3635 32.84H49.6195V37H48.3555V27.176H52.0035C53.9715 27.176 55.2195 28.168 55.2195 30.024C55.2195 31.656 54.2595 32.584 52.7235 32.792L55.6195 37H54.1795L51.3635 32.84ZM49.6195 28.28V31.768H51.9715C53.2675 31.768 53.9715 31.112 53.9715 30.024C53.9715 28.936 53.2675 28.28 51.9715 28.28H49.6195ZM57.1836 37V27.176H58.4476V35.864H63.4556V37H57.1836Z"
        fill="#B4BFCD"
      />
    </g>
    <path
      d="M93 8C93 5.79086 94.7909 4 97 4H182C184.209 4 186 5.79086 186 8V56C186 58.2091 184.209 60 182 60H97C94.7909 60 93 58.2091 93 56V8Z"
      fill="#192232"
    />
    <path
      d="M93 8C93 5.79086 94.7909 4 97 4H182C184.209 4 186 5.79086 186 8V56C186 58.2091 184.209 60 182 60H97C94.7909 60 93 58.2091 93 56V8Z"
      fill="url(#paint10_linear_14845_15382)"
      fillOpacity="0.75"
    />
    <g style={{ mixBlendMode: 'multiply' }} filter="url(#filter2_f_14845_15382)">
      <path
        d="M102.347 96L93.5 56H102.347V96ZM177.545 96H102.348V56H177.545V96ZM186.394 56L177.547 96V56H186.394Z"
        fill="url(#paint11_linear_14845_15382)"
      />
    </g>
    <path
      d="M93 36C93 33.7909 94.7909 32 97 32H182C184.209 32 186 33.7909 186 36V56C186 58.2091 184.209 60 182 60H97C94.7909 60 93 58.2091 93 56V36Z"
      fill="#192232"
    />
    <path
      d="M93 36C93 33.7909 94.7909 32 97 32H182C184.209 32 186 33.7909 186 36V56C186 58.2091 184.209 60 182 60H97C94.7909 60 93 58.2091 93 56V36Z"
      fill="url(#paint14_linear_14845_15382)"
      fillOpacity="0.75"
    />
    <g filter="url(#filter3_i_14845_15382)">
      <path
        d="M101 31.2C101 24.4794 101 21.1191 102.308 18.5521C103.458 16.2942 105.294 14.4584 107.552 13.3079C110.119 12 113.479 12 120.2 12H158.8C165.521 12 168.881 12 171.448 13.3079C173.706 14.4584 175.542 16.2942 176.692 18.5521C178 21.1191 178 24.4794 178 31.2V32.8C178 39.5206 178 42.8809 176.692 45.4479C175.542 47.7058 173.706 49.5416 171.448 50.6921C168.881 52 165.521 52 158.8 52H120.2C113.479 52 110.119 52 107.552 50.6921C105.294 49.5416 103.458 47.7058 102.308 45.4479C101 42.8809 101 39.5206 101 32.8V31.2Z"
        fill="#243043"
      />
      <path
        d="M101 31.2C101 24.4794 101 21.1191 102.308 18.5521C103.458 16.2942 105.294 14.4584 107.552 13.3079C110.119 12 113.479 12 120.2 12H158.8C165.521 12 168.881 12 171.448 13.3079C173.706 14.4584 175.542 16.2942 176.692 18.5521C178 21.1191 178 24.4794 178 31.2V32.8C178 39.5206 178 42.8809 176.692 45.4479C175.542 47.7058 173.706 49.5416 171.448 50.6921C168.881 52 165.521 52 158.8 52H120.2C113.479 52 110.119 52 107.552 50.6921C105.294 49.5416 103.458 47.7058 102.308 45.4479C101 42.8809 101 39.5206 101 32.8V31.2Z"
        fill="url(#paint15_radial_14845_15382)"
      />
      <path
        d="M118.168 27.176H124.424V28.296H119.416V31.4H123.96V32.52H119.416V35.864H124.424V37H118.168V27.176ZM134.034 27.176V37H133.106L127.618 29.192V37H126.402V27.176H127.602L132.834 34.648V27.176H134.034ZM135.683 28.296V27.176H143.795V28.296H140.371V37H139.107V28.296H135.683ZM145.449 27.176H151.705V28.296H146.697V31.4H151.241V32.52H146.697V35.864H151.705V37H145.449V27.176ZM156.692 32.84H154.948V37H153.684V27.176H157.332C159.3 27.176 160.548 28.168 160.548 30.024C160.548 31.656 159.588 32.584 158.052 32.792L160.948 37H159.508L156.692 32.84ZM154.948 28.28V31.768H157.3C158.596 31.768 159.3 31.112 159.3 30.024C159.3 28.936 158.596 28.28 157.3 28.28H154.948Z"
        fill="#B4BFCD"
      />
    </g>
    <defs>
      <clipPath id="paint0_angular_14845_15382_clip_path">
        <path d="M5 8C5 5.79086 6.79086 4 9 4H85C87.2091 4 89 5.79086 89 8V56C89 58.2091 87.2091 60 85 60H9C6.79086 60 5 58.2091 5 56V8Z" />
      </clipPath>
      <filter
        id="filter0_f_14845_15382"
        x="0.5"
        y="52"
        width="92"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_14845_15382" />
      </filter>
      <filter
        id="filter1_i_14845_15382"
        x="12"
        y="11"
        width="69"
        height="41"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" dy="-1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.309804 0 0 0 0 0.372549 0 0 0 0 0.462745 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_14845_15382" />
      </filter>
      <filter
        id="filter2_f_14845_15382"
        x="89.5"
        y="52"
        width="100.895"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_14845_15382" />
      </filter>
      <filter
        id="filter3_i_14845_15382"
        x="100"
        y="11"
        width="78"
        height="41"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" dy="-1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.309804 0 0 0 0 0.372549 0 0 0 0 0.462745 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_14845_15382" />
      </filter>
      <linearGradient
        id="paint2_linear_14845_15382"
        x1="47"
        y1="4"
        x2="47"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192232" />
        <stop offset="0.172666" stopColor="#192232" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_14845_15382"
        x1="46.5"
        y1="56"
        x2="46.5"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#151D2B" />
        <stop offset="1" stopColor="#36455A" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_14845_15382"
        x1="47"
        y1="32"
        x2="47"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.65" stopColor="#192232" stopOpacity="0" />
        <stop offset="1" stopColor="#192232" />
      </linearGradient>
      <radialGradient
        id="paint7_radial_14845_15382"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(42.3691 43.1679 -73.3855 24.923 27.2954 8.83207)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192232" />
        <stop offset="0.65" stopColor="#243043" />
        <stop offset="1" stopColor="#36455A" />
      </radialGradient>
      <linearGradient
        id="paint10_linear_14845_15382"
        x1="139.5"
        y1="4"
        x2="139.5"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192232" />
        <stop offset="0.172666" stopColor="#192232" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_14845_15382"
        x1="139.947"
        y1="56"
        x2="139.947"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#151D2B" />
        <stop offset="1" stopColor="#36455A" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_14845_15382"
        x1="139.5"
        y1="32"
        x2="139.5"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.65" stopColor="#192232" stopOpacity="0" />
        <stop offset="1" stopColor="#192232" />
      </linearGradient>
      <radialGradient
        id="paint15_radial_14845_15382"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(47.9768 43.1679 -83.0983 24.923 117.187 8.83207)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#192232" />
        <stop offset="0.65" stopColor="#243043" />
        <stop offset="1" stopColor="#36455A" />
      </radialGradient>
    </defs>
  </svg>
);
